/* Read More function added by WeBOOST Yuan */

function weboostClickMore() {
  document
    .getElementById("weboost-moretext-section")
    .classList.toggle("weboost-toggle-display");

  if (jQuery("#weboost-moreless-button-id").text() == "Read more") {
    jQuery("#weboost-moreless-button-id").text("Read less");
  } else {
    jQuery("#weboost-moreless-button-id").text("Read more");
  }
}
